<cpc-policy-card [ngClass]="state.name" [variant]="state.badge">
    <cpc-policy-card-header class="cpc-policy-card-header_{{state.badge}}">
        <cpc-icon left [icon]="getGroupByLobId(policy.lineOfBusinessId).icon"
            color="{{ (policy.isElectricVehicle) ? '#3da556' : '#006192' }}" borderStyle="circle"
            backgroundColor="#fff"></cpc-icon>
        <ng-container center>
            <p translate *ngIf="!policy.isElectricVehicle">
                {{'active-insurance-group.' + getGroupByLobId(policy.lineOfBusinessId).name}}</p>
            <p translate *ngIf="policy.isElectricVehicle">{{'active-insurance-group.car-insurance-ek'}}</p>
        </ng-container>
        <ng-container right>
            <div>
                <cpc-badge [variant]="state.badge">
                    {{'product-state.' + state.name | translate}}
                    <cpc-icon icon="check-circle"></cpc-icon>
                </cpc-badge>
            </div>
        </ng-container>
    </cpc-policy-card-header>
    <cpc-policy-card-content class="policy-card-content" [borderBottom]="state === policyStates.active ? true : false">
        <cpc-policy-card-entry skipFromHeightAligment="true">
            <span title translate>home.product-name</span>
            <b>{{ this.b2b.getProductName(policy) }}</b>
        </cpc-policy-card-entry>
        <cpc-policy-card-entry skipFromHeightAligment="true">
            <span title translate>policy.policy-number</span>
            <b>{{policy.policyNumber}}</b>
        </cpc-policy-card-entry>
        <div class="button-row">
            <a href="{{'file-a-claim.'+commonService.env+'.lob_' + policy.lineOfBusinessId + responsibility | translate}}"
                target="_blank" *ngIf="policy.canFileAClaim">
                <button nxPlainButton type="button" class="file-a-claim" (click)="gtm()">
                    {{'policy.file-a-claim' | translate}}<nx-icon name="launch" class="nx-margin-left-2xs"></nx-icon>
                </button>
            </a>
            <a [routerLink]="['/moje-poistky', policy.policyState.name, policy.policyNumber]">
                <button nxButton="secondary small" type="button">
                    {{'policy.details' | translate}}
                </button>
            </a>
        </div>
    </cpc-policy-card-content>
</cpc-policy-card>